var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clst-1{opacity:0.1;}.clst-2{fill:none;}.clst-3{fill:#5059c9;}.clst-4{fill:#7b83eb;}.clst-5{opacity:0.5;}.clst-6{fill:#4b53bc;}.clst-7{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Teams_24x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clst-1",
    d: "M8,10.12V17.5A5.4,5.4,0,0,0,8.61,20h5A1.5,1.5,0,0,0,15,18.65V9l-.28,0H9.12A1.12,1.12,0,0,0,8,10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-1",
    d: "M13.83,6h-3A3.29,3.29,0,0,0,14,8.31a3.33,3.33,0,0,0,1-.17v-1A1.18,1.18,0,0,0,13.83,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "clst-2",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-3",
    d: "M22.87,9h-5l-1.39,1.13v5.59a3.76,3.76,0,0,0,7.51,0V10.13A1.12,1.12,0,0,0,22.87,9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Head",
    className: "clst-3",
    cx: 20.5,
    cy: 5.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-4",
    d: "M9.12,9h8.76A1.12,1.12,0,0,1,19,10.12V17.5A5.5,5.5,0,0,1,13.5,23h0A5.5,5.5,0,0,1,8,17.5V10.12A1.12,1.12,0,0,1,9.12,9Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Head-2",
    "data-name": "Head",
    className: "clst-4",
    cx: 14,
    cy: 5,
    r: 3.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-5",
    d: "M8,10.12V17.5A5.4,5.4,0,0,0,8.61,20h5A1.5,1.5,0,0,0,15,18.65V9l-.28,0H9.12A1.12,1.12,0,0,0,8,10.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-5",
    d: "M13.83,6h-3A3.29,3.29,0,0,0,14,8.31a3.33,3.33,0,0,0,1-.17v-1A1.18,1.18,0,0,0,13.83,6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Back_Plate",
    "data-name": "Back Plate",
    className: "clst-6",
    y: 5,
    width: 14,
    height: 14,
    rx: 1.17
  }), /*#__PURE__*/React.createElement("path", {
    className: "clst-7",
    d: "M10.18,9.58H7.79V16H6.22V9.58H3.82V8h6.36Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeams);
export default __webpack_public_path__ + "static/media/Teams.9e49b25392b48127b671bb5037f1ab90.svg";
export { ForwardRef as ReactComponent };